import { render, staticRenderFns } from "./KkArticle.vue?vue&type=template&id=7224fd66&scoped=true"
import script from "./KkArticle.vue?vue&type=script&lang=js"
export * from "./KkArticle.vue?vue&type=script&lang=js"
import style0 from "./KkArticle.vue?vue&type=style&index=0&id=7224fd66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7224fd66",
  null
  
)

export default component.exports